import { ExplainerVideo } from "../../components/ExplainerVideo";
import { InfoLayout } from "../../components/InfoLayout";

export function ForEducatorsPage() {
  return (
    <InfoLayout
      title="For educators"
      lead="PyDialog gives instructors a live view of genuine understanding across their class — with the tools to intervene at the right moment."
    >
      <ExplainerVideo
        src="/videos/how-it-works-teachers.mp4"
        captions="/videos/how-it-works-teachers.vtt"
        poster="/videos/how-it-works-teachers.jpg"
        title="How PyDialog works for teachers"
        caption="A 90-second tour: apply to teach, follow your class on the dashboard, and write your own lessons."
      />

      <div className="card">
        <h3>Your own learners, your own lessons</h3>
        <p>
          Instructors work independently: you own the curricula you offer and see
          only your own cohort. Learners self-register; teachers apply with the
          subjects they teach, and an administrator verifies each one before the
          account opens.
        </p>
      </div>

      <div className="card">
        <h3>A live dashboard</h3>
        <p>
          The instructor dashboard shows cohort-wide mastery, an objective heatmap
          of where the class is struggling, and per-learner reports with objective
          scores, recent dialogues, and the specific misconceptions that came up.
        </p>
      </div>

      <div className="card">
        <h3>Attempt limits</h3>
        <p>
          Learners get a fixed number of attempts to pass a lesson before it locks
          — a built-in prompt to seek help instead of guessing repeatedly. A
          learner's report shows you when a lesson has locked. Clearing the
          counter is an admin action, so ask your administrator to lift it; the
          learner keeps their full history either way.
        </p>
      </div>

      <div className="card">
        <h3>How answers are graded</h3>
        <p>
          Written answers are graded by an AI marker that reads the explanation
          against the objective's key concepts. A correct paraphrase earns
          credit, and repeating the expected words without understanding them
          does not. Multiple-choice answers are marked by exact match.
        </p>
        <p>
          If no grading key is configured, or a grading call fails, PyDialog
          falls back to an offline keyword-coverage heuristic so the dialogue
          can still be completed. Those scores measure wording rather than
          reasoning, so treat them as provisional — your administrator can
          confirm which grader an instance is running.
        </p>
      </div>
    </InfoLayout>
  );
}
